export default __webpack_public_path__ + "static/media/negative.7646e826.svg";